import React from "react";
import "./ProductsSection.css";
import { Star } from "lucide-react";
import { useNavigate } from "react-router-dom";
export default function ProductsSection() {
  const navigate = useNavigate();
  const products = [
    {
      img: "/assets/p1.png",
      title: "Gloss Enamel",
      subtitle: "Shiny, weather-resistant.",
      price: "Rs 265 - Rs 3575",
      rating: 5,
      reviews: 361,
    },
    {
      img: "/assets/p2.png",
      title: "Wall Putty",
      subtitle: "Improving paint finish.",
      price: "Rs 265 - Rs 3575",
      rating: 5,
      reviews: 321,
    },
    {
      img: "/assets/p3.png",
      title: "Plastic Emulsion",
      subtitle: "Durable, smooth finish.",
      price: "Rs 265 - Rs 3575",
      rating: 5,
      reviews: 121,
    },
    {
      img: "/assets/p4.png",
      title: "High Class Emulsion",
      subtitle: "Elegant matte finish.",
      price: "Rs 265 - Rs 3575",
      rating: 5,
      reviews: 207,
    },
  ];

  return (
    <section className="products-sectionb">
      <h2>Shop Our Products</h2>
      <p className="section-subtitleb">
        Paint calculator simplifies your project by accurately measuring the
        needed paint, making painting easier.
      </p>

      <div className="products-gridb">
        {products.map((product, index) => (
          <div className="product-cardb" key={index}>
            <img
              src={product.img}
              alt={product.title}
              className="product-imgb"
            />

            <div className="product-infob">
              {/* Left Side */}
              <div className="info-leftb">
                <h4 className="product-titleb">{product.title}</h4>
                <p className="product-subtitleb">{product.subtitle}</p>
              </div>

              {/* Right Side */}
              <div className="info-rightb">
                <div className="product-priceb">{product.price}</div>
                <div className="product-ratingb">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                      key={i}
                      size={14}
                      fill={i < Math.floor(product.rating) ? "#f6a700" : "none"}
                      stroke="#f6a700"
                    />
                  ))}
                  <span className="reviewsb">({product.reviews})</span>
                </div>
              </div>
            </div>

            {/* <button className="buy-btnb" onClick={() => navigate(`/e-store`)}>
              Select
            </button> */}
            <button
              className="buy-btnb"
              onClick={() => {
                navigate("/e-store");
                window.scrollTo(0, 0); // Scroll to top
              }}
            >
              Select
            </button>
          </div>
        ))}
      </div>

      <button className="view-all-btnb">View All Products</button>
    </section>
  );
}
